import {whenReady} from "./shared/browser-events.js";
import {setupAddressFieldCodeSupport} from "./frontend/groundhogg/woocommerce-address-field-support.js";

whenReady()
	.then(() => {
		setupAddressFieldCodeSupport();
	})
